import store from '@/store';
import router from '@/router';

export const onFulfilled = response => response;

export const onRejected = error => {
	if (process.env.APP_VUE_DEBUG_DISPLAY_AXIOS_ERROS) {
		// eslint-disable-next-line
		console.error(error);
	}

	switch (error.response.status) {
		case 401:
		case 429:
			store.dispatch('logoutLocal').then(response => {
				if (store.getters.getAppsEmployeeLoginStatus) {
					store.commit('logoutEmployee');
				} else {
					if(router.currentRoute.name !== 'login'){
						router.push({ name: 'login' });
					}
				}
			});
			break;
		case 403:
			router.push({ name: 'Forbidden' });
			break;
		default:
			store.commit('addLog', {
				type: 'axios',
				error: error,
			});
			break;
	}

	return Promise.reject(error);
};
